import { Box, Flex, VStack, Text, Center, Input } from "@chakra-ui/react";
import { Outlet, useLocation } from "react-router-dom";
import { UserService } from "../../services/UserService";
import { RxAvatar } from "react-icons/rx";
import { TbCloudDataConnection } from "react-icons/tb";
import { VscServerProcess } from "react-icons/vsc";
import { capitalizeFirstLetter } from "../../utils/capitalizeFirstLetter";
import {
  FaCaretDown,
  FaPlus,
  FaRegCircle,
  FaRegCircleDot,
  FaRegCircleXmark,
} from "react-icons/fa6";
import { GrNotes } from "react-icons/gr";
import { IoMail } from "react-icons/io5";
import { FiSettings } from "react-icons/fi";

import { useState } from "react";
import { RiCloseFill } from "react-icons/ri";
import {
  INodeNav,
  NodeSidebar,
} from "../../components/NodeSideBar/NodeSideBar";
import { ToolBar } from "../../components/Toolbar/Toolbar";
import { ProcessModeler } from "../ProcessModular/ProcessModular";
import { useProcessModular } from "../ProcessModular/useProcessModular";
import { useSelector } from "react-redux";
import { RootState } from "@/services/state/store";
import { ProcessDesignerBar } from "../../components/Toolbar/ProcessDesignerBar";
import { ToolBarIcons } from "../../components/Toolbar/ToolBarIcons";
import { AiOutlineOpenAI } from "react-icons/ai";
import { FaSalesforce } from "react-icons/fa";
import { SiSap } from "react-icons/si";
import { SiMulesoft } from "react-icons/si";

export const ProcessDesigner = ({
  isInstanceBased,
}: {
  isInstanceBased?: boolean;
}) => {
  const [activeCategory, setActiveCategory] = useState<string | null>(null);
  const [activeSubNav, setActiveSubNav] = useState<string | null>(null);
  const [searchTerm, setSearchTerm] = useState<string>("");

  function getIconFromCategoryType(categoryType: string) {
    switch (categoryType) {
      default:
        return FaCaretDown;
    }
  }

  // Get current user's email to conditionally show connectors
  const currentUserEmail = UserService.getUserEmail();
  const allowedConnectorEmails = ["madan@eizen.ai", "sami.mahammad@eizen.ai"];
  const showConnectors = allowedConnectorEmails.includes(currentUserEmail || "");

  const sidebarItems = [
    {
      categoryType: "activities",
      icon: "activity.png",
      items: [
        {
          id: "scriptTask",
          label: "Script Task",
          nodeTypCd: "SCRIPT_TASK",
          shape: "rectangle",
          icon: GrNotes,
          iconStyle: {},
          image: 4,
        },
        {
          id: "subProcess",
          label: "Sub Process",
          nodeTypCd: "SUB_PROC_TASK",
          shape: "rectangle",
          icon: VscServerProcess,
          iconStyle: {},
          image: 11,
        },
      ],
    },
    {
      categoryType: "AI Services",
      icon: "ai.png",
      items: [
        {
          id: "aiAgent",
          label: "Call AGENT",
          nodeTypCd: "SERVICE_TASK",
          shape: "rectangle",
          icon: RxAvatar,
          iconStyle: {},
          image: 9,
        },
        {
          id: "planner LLM",
          label: "Call LLM",
          nodeTypCd: "SERVICE_TASK",
          shape: "rectangle",
          icon: TbCloudDataConnection,
          iconStyle: {},
          image: 10,
        },
      ],
    },
    {
      categoryType: "events",
      icon: "category.png",
      items: [
        {
          id: "startEvent",
          label: "Start",
          nodeTypCd: "START_EV",
          shape: "left-rounded-rectangle",
          icon: FaRegCircle,
          iconStyle: {},
          image: 1,
        },
        {
          id: "endEvent",
          label: "End",
          nodeTypCd: "END_EV",
          shape: "right-rounded-rectangle",
          icon: FaRegCircleDot,
          iconStyle: {},
          image: 2,
        },
        {
          id: "terminateEvent",
          label: "Terminate",
          nodeTypCd: "TERMINATE_EV",
          shape: "right-rounded-rectangle",
          icon: FaRegCircleXmark,
          iconStyle: {},
          image: 3,
        },
      ],
    },

    {
      categoryType: "gateways",
      icon: "gateway.png",
      items: [
        {
          id: "orGateway",
          label: "OR",
          nodeTypCd: "OR_GW",
          shape: "square",
          icon: FaRegCircle,
          iconStyle: {
            backgroundColor: "gray.500",
            color: "white",
            transform: "rotate(45deg)",
            p: "4px",
          },
          image: 5,
        },
        {
          id: "xorGateway",
          label: "XOR",
          nodeTypCd: "XOR_GW",
          shape: "square",
          icon: FaPlus,
          iconStyle: {
            backgroundColor: "gray.500",
            color: "white",
            transform: "rotate(45deg)",
          },
          image: 6,
        },
        {
          id: "andGateway",
          label: "AND",
          nodeTypCd: "AND_GW",
          shape: "square",
          icon: RiCloseFill,
          iconStyle: {
            backgroundColor: "gray.500",
            color: "white",
            transform: "rotate(45deg)",
          },
          image: 12,
        },
      ],
    },
    {
      categoryType: "integrations",
      icon: "integration.png",
      items: [
        {
          id: "serviceTask",
          label: "Service Task",
          nodeTypCd: "SERVICE_TASK",
          shape: "rectangle",
          icon: FiSettings,
          iconStyle: {},
          image: 7,
        },
      ],
    },
    {
      categoryType: "communication",
      icon: "communication.png",
      items: [
        {
          id: "sendEmail",
          label: "Send Email",
          nodeTypCd: "SERVICE_TASK",
          shape: "rectangle",
          icon: IoMail,
          iconStyle: {},
          image: 8,
        },
      ],
    },
    {
      categoryType: "connectors",
      icon: "communication.png",
      items: [
        {
          id: "OpenAI",
          label: "OpenAI",
          nodeTypCd: "SCRIPT_TASK",
          shape: "rectangle",
          icon: AiOutlineOpenAI,
          iconStyle: {},
          image: 13,
        },
        {
          id: "Salesforce",
          label: "Salesforce",
          nodeTypCd: "SCRIPT_TASK",
          shape: "rectangle",
          icon: FaSalesforce,
          iconStyle: {},
          image: 14,
        },
        {
          id: "SAP",
          label: "SAP",
          nodeTypCd: "SCRIPT_TASK",
          shape: "rectangle",
          icon: SiSap,
          iconStyle: {},
          image: 15,
        },
        {
          id: "ServiceNow",
          label: "ServiceNow",
          nodeTypCd: "SCRIPT_TASK",
          shape: "rectangle",
          icon: IoMail,
          iconStyle: {},
          image: 16,
        },
        {
          id: "MuleSoft",
          label: "MuleSoft",
          nodeTypCd: "SCRIPT_TASK",
          shape: "rectangle",
          icon: SiMulesoft,
          iconStyle: {},
          image: 17,
        },
        {
          id: "agent",
          label: "AGENT",
          nodeTypCd: "SCRIPT_TASK",
          shape: "rectangle",
          icon: RxAvatar,
          iconStyle: {},
          image: 9,
        },
        {
          id: "LLM",
          label: "LLM",
          nodeTypCd: "SCRIPT_TASK",
          shape: "rectangle",
          icon: TbCloudDataConnection,
          iconStyle: {},
          image: 10,
        },
      ],
    },
  ];

  // Filter out connectors if user is not madan@eizen.ai
  const filteredSidebarItems = showConnectors
    ? sidebarItems
    : sidebarItems.filter((item) => item.categoryType !== "connectors");

  const userNavs: INodeNav[] = filteredSidebarItems.map((category) => ({
    icon: getIconFromCategoryType(category.categoryType),
    link: `/process-design`,
    label: capitalizeFirstLetter(category.categoryType),
    active: false,
    width: 4,
    height: 4,
    enabled: true,
    subNavs: category.items.map((item) => ({
      icon: item.icon,
      link: `/process-design`,
      label: item.label,
      nodeTypCd: item.nodeTypCd,
      shape: item.shape,
      iconStyle: item.iconStyle,
      image: item.image,
      active: false,
      width: 4,
      height: 4,
      enabled: true,
    })),
  }));

  const location = useLocation();

  const handleOnHelp = () => {
    // TODO: Help Functionality
  };

  const getNavs = (pathname: string) => {
    return userNavs.map((nav) => ({
      ...nav,
      active: nav.label === activeCategory,
      subNavs: nav.subNavs.map((subNav) => ({
        ...subNav,
        active: subNav.label === activeSubNav,
      })),
    }));
  };

  const onCategoryClick = (categoryLabel: string) => {
    if (categoryLabel === activeCategory) {
      setActiveCategory(null);
    } else {
      setActiveCategory(categoryLabel);
      setActiveSubNav(null);
    }
  };

  // Function to handle subnav click
  const onSubNavClick = (subNavLabel: string) => {
    setActiveSubNav(subNavLabel);
  };

  const handleOnLogout = () => {
    UserService.doLogout();
  };

  // Filter navigation items based on the search term
  const navs = getNavs(location.pathname);
  const filteredNavs = navs.filter((nav) => {
    const labelMatch = nav.label
      .toLowerCase()
      .includes(searchTerm.toLowerCase());
    const subNavMatch = nav.subNavs.some((subNav) =>
      subNav.label.toLowerCase().includes(searchTerm.toLowerCase())
    );
    return labelMatch || subNavMatch;
  });

  const {
    nodes,
    edges,
    drop,
    onAdd,
    onConnect,
    onSaveToDB,
    setRfInstance,
    onNodesChange,
    onEdgesChange,
    onEdgeClick,
    onJsonRestore1,
    onFileRestore,
    onNodeDragStop,
    checkNodes,
    handleNodeIoDetails,
    handleCopyNode,
    handlePasteNoded,
    isEdgeLabelModalOpen,
    onEdgeLabelModalClose,
    modalCoordinates,
    selectedEdge,
    handleEdgeSave,
    runProcess,
  } = useProcessModular({ isInstanceBased });

  return (
    <Box
      className="Main"
      bg="rgba(0, 0, 0, 0.8)"
      backdropFilter="blur(20px)"
      m={-8}
      position="fixed"
      width="100%"
      color="white"
    >
      <VStack>
        <Box width="100%">
          <ToolBar
            onAdd={onAdd}
            onSaveToDB={onSaveToDB}
            onFileRestore={onFileRestore}
            checkNodes={checkNodes}
            isInstanceBased={isInstanceBased}
            onJsonRestore1={onJsonRestore1}
          />
          <ToolBarIcons
            onAdd={onAdd}
            onSaveToDB={onSaveToDB}
            onFileRestore={onFileRestore}
            checkNodes={checkNodes}
            handleCopyNode={handleCopyNode}
            handlePasteNoded={handlePasteNoded}
            runProcess={runProcess}
          />
          <ProcessDesignerBar />
        </Box>
        <Flex width="100%" height="78vh">
          {/* Sidebar with Search Bar */}
          <Box
            flex="1"
            height="78vh"
            p={4}
            bg="rgba(255, 255, 255, 0.05)"
            backdropFilter="blur(20px)"
            borderRadius="20px"
            border="1px solid rgba(255, 255, 255, 0.1)"
          >
            <Input
              placeholder="Search Nodes..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              mb={3}
              width="100%"
              bg="rgba(255, 255, 255, 0.1)"
              borderColor="rgba(255, 255, 255, 0.2)"
              color="white"
              _placeholder={{ color: "rgba(255, 255, 255, 0.6)" }}
              _focus={{
                borderColor: "brand.500",
                boxShadow: "0 0 0 1px rgba(118, 82, 247, 0.5)",
              }}
            />

            <NodeSidebar
              navs={filteredNavs}
              onHelp={handleOnHelp}
              onLogout={handleOnLogout}
              onCategoryClick={onCategoryClick}
              onSubNavClick={onSubNavClick}
            />
          </Box>
          <Box flex="9" width="100%" ml={2} height="75vh">
            <Box
              flex="9"
              width="100%"
              bg="rgba(255, 255, 255, 0.05)"
              backdropFilter="blur(20px)"
              borderRadius="20px"
              border="1px solid rgba(255, 255, 255, 0.1)"
              mr={2}
            >
              <ProcessModeler
                nodes={nodes}
                edges={edges}
                drop={drop}
                onAdd={onAdd}
                onConnect={onConnect}
                onSaveToDB={onSaveToDB}
                setRfInstance={setRfInstance}
                onNodesChange={onNodesChange}
                onEdgesChange={onEdgesChange}
                onEdgeClick={onEdgeClick}
                onFileRestore={onFileRestore}
                onNodeDragStop={onNodeDragStop}
                handleNodeIoDetails={handleNodeIoDetails}
                isEdgeLabelModalOpen={isEdgeLabelModalOpen}
                onEdgeLabelModalClose={onEdgeLabelModalClose}
                modalCoordinates={modalCoordinates}
                selectedEdge={selectedEdge}
                handleEdgeSave={handleEdgeSave}
              />
            </Box>
          </Box>
        </Flex>
      </VStack>
    </Box>
  );
};
